import type { GraphIssue } from "@velizhanin-dev/bot-scenario"
import type { DraftNode, ScenarioDraft } from "@/entities/bot-builder"

/** Конфиг черновика читается мягко: недописанный блок: нормальное состояние. */
export type Config = Record<string, unknown>

export interface EditorProps {
	config: Config
	onChange: (next: Config) => void
	issues: GraphIssue[]
	draft: ScenarioDraft
	node: DraftNode
	scenarioId: string
}

export const readString = (config: Config, key: string): string => {
	const value = config[key]
	return typeof value === "string" ? value : ""
}

export const readNumber = (config: Config, key: string): number | undefined => {
	const value = config[key]
	return typeof value === "number" && Number.isFinite(value) ? value : undefined
}

export function withField(config: Config, key: string, value: unknown): Config {
	if (value === undefined) {
		const { [key]: _removed, ...rest } = config
		return rest
	}
	return { ...config, [key]: value }
}

/** Пустое поле числа: ключ убирается, иначе число. */
export function parseOptionalNumber(raw: string): number | undefined {
	if (raw.trim() === "") return undefined
	const value = Number(raw.replace(",", "."))
	return Number.isFinite(value) ? value : undefined
}
